import { ref } from 'vue';
import { useRoute } from 'vue-router';
import api from '../services/api';

/**
 * useVoicePricing
 *
 * Accesso condiviso di sola lettura alla stima costo/minuto del canale voce
 * ({ enabled, estimatedCostPerMinuteEur }). Config globale → stato module-scoped,
 * fetch una volta per sessione. Endpoint sotto lo scope bot (workspaceId/botId
 * dai params della route bot-editor). Gemello di useWhatsappPricing.
 */
const pricing = ref({ enabled: false, estimatedCostPerMinuteEur: 0 });
const loaded = ref(false);
let inflight = null;

export function useVoicePricing() {
  const route = useRoute();

  const fetchPricing = async () => {
    if (loaded.value) return pricing.value;
    if (inflight) return inflight;

    const workspaceId = route.params.workspaceId;
    const botId = route.params.id;
    if (!workspaceId || !botId) return pricing.value;

    inflight = (async () => {
      try {
        const { data } = await api.get(`/workspaces/${workspaceId}/bots/${botId}/voice/pricing`);
        if (data?.success && data.data) {
          pricing.value = {
            enabled: !!data.data.enabled,
            estimatedCostPerMinuteEur: Number(data.data.estimatedCostPerMinuteEur) || 0,
          };
        }
        loaded.value = true;
      } catch (err) {
        Console.error('[useVoicePricing] fetch failed:', err);
      } finally {
        inflight = null;
      }
      return pricing.value;
    })();

    return inflight;
  };

  return { pricing, loaded, fetchPricing };
}
